export function titleCase(str: string, delimiter: string) {
  let sentence = str.toLowerCase().split(delimiter);
  return sentence
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}
